import { ReactNode } from "react";
import styles from "./Breadcrumbs.module.css";

/** The `Breadcrumbs` component properties. */
export interface BreadcrumbsProps {

  /** The component children. */
  readonly children?: ReactNode;
}

/** Component that renders out the set of provided breadcrumbs. */
export const Breadcrumbs = (props: BreadcrumbsProps): ReactNode => {
  const { children } = props;

  return <div className={`${styles.root} breadcrumbs`}>{children}</div>;
};
